import React from 'react';
import classNames from 'classnames';

import Field, { hasDataInFields } from '../../Field';
import BlockContainer from '../BlockContainer';

import css from './BlockAmbassadorImg.module.css';

const SparkleGreen = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M24 12C17.7782 12 12 17.7782 12 24C12 17.7782 6.22183 12 0 12C6.22183 12 12 6.22183 12 0C12 6.22183 17.7782 12 24 12Z" fill="#2c7859"/>
  </svg>
);

const SparkleWine = () => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M24 12C17.7782 12 12 17.7782 12 24C12 17.7782 6.22183 12 0 12C6.22183 12 12 6.22183 12 0C12 6.22183 17.7782 12 24 12Z" fill="#8C265C"/>
  </svg>
);

const BlockAmbassadorImg = props => {
  const {
    blockId,
    className,
    rootClassName,
    media,
    responsiveImageSizes,
    options,
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const hasMedia = hasDataInFields([media], options);

  return (
    <BlockContainer id={blockId} className={classes}>
      <div className={css.imageWrap}>
        {/* Green sparkle — top right, outside the arch */}
        <span className={css.sparkleTopRight}>
          <SparkleGreen />
        </span>

        {/* Arch image */}
        {hasMedia ? (
          <div className={css.media}>
            <Field data={media} sizes={responsiveImageSizes} options={options} />
          </div>
        ) : null}

        {/* Wine sparkle — bottom right, outside the arch */}
        <span className={css.sparkleBottomRight}>
          <SparkleWine />
        </span>
      </div>
    </BlockContainer>
  );
};

export default BlockAmbassadorImg;
